//Import Store
import { createStore } from "vuex"
// firebase imports
import { auth } from '../firebase'
import {
    signInWithEmailAndPassword,
    signOut,
    onIdTokenChanged,
    getIdTokenResult
} from 'firebase/auth'
import {
    onValue,
    ref as storageRef,
    query,
    orderByChild,
    equalTo,
} from "firebase/database";
import { database } from "../firebase";

//Import persistedstate
import createPersistedState from "vuex-persistedstate";
import router from '../router'

const store = createStore({

    state: {
        user: null

    },
    getters: {
        getUser(state) {
            return state.user
        }

    },
    mutations: {
        setuser(state, payload) {
            //Set user to vuex
            state.user = payload
        }

    },
    actions: {
        initFirebase(context) {
            onIdTokenChanged(auth, (user) => {
                if (user) {
                    //Fetch User from DB
                    context.dispatch('checkUser', user)

                } else {
                    const routerCurrentPath = router.currentRoute;

                    if(routerCurrentPath.meta.requiresAuth) {
                        /** Sent to login */
                        router.push("/login")
                    }
                    
                    // User is signed out
                    context.commit('setuser', {})
                }
            });
        },

        async checkUser(context, userFirebase) {
            //Get UserData from database
            const userData = query(
                storageRef(database, "user"),
                orderByChild("username"),
                equalTo(userFirebase.email)
            );
            onValue(userData, (snapshot) => {
                var userData = snapshot.val();

                const userId = Object.keys(userData)[0]

                userData = userData[userId]

                //Build userData
                const storeUser = {
                    username: userData.username,
                    role: userData.role,
                    firstName: userData.firstName,
                    lastName: userData.lastName
                }

                //Commit to store
                context.commit('setuser', storeUser)

            });
        },

        async signIn(context, { username, password }) {
            await signInWithEmailAndPassword(auth, username, password);
            var firebaseUser = await getIdTokenResult(auth.currentUser)
            return firebaseUser
        },

        async signOut() {
            await signOut(auth)
        },


    },
    plugins: [createPersistedState()]
})

export default store